import { useTenantConfig } from 'utils/hooks/useTenantConfig';
import { InitialEngagementStatusSettings } from './EngagementStatus.types';

export const useEngagementStatusSelector = (): InitialEngagementStatusSettings => {
  const tenantConfig = useTenantConfig();

  const engagementOffboardAutoTransition = tenantConfig?.features['engagement-offboard-auto-transition'];

  return {
    engagementOffboardAutoTransition,
    enabled: engagementOffboardAutoTransition?.enabled || false,
    status: engagementOffboardAutoTransition?.config.status,
    daysShift: parseInt(engagementOffboardAutoTransition?.config['days-shift'], 10) || 0,
    useWorkerTimezone: engagementOffboardAutoTransition?.config['use-worker-timezone'] === 'true'
  };
};
